import { StickmanCanvas } from "./StickmanCanvas.tsx";

export default function App() {
  return (
    <div className="stage">
      <StickmanCanvas />
    </div>
  );
}
